import Intro from './Intro'
import FeatureImage from './FeatureImage'
import Content from './Content'
import Related from './Related'

import s from './SinglePost.module.sass'

function SinglePost({ post, relatedPosts }: any) {
    return (
        <div className={s.SinglePost}>
            <Intro post={post} />
            <FeatureImage post={post} />
            <Content post={post} />
            <Related relatedPosts={relatedPosts} />
        </div>
    )
}

export default SinglePost
